import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayoutCustom2 from "examples/LayoutContainers/DashboardLayoutCustom2";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import backDashboard from "assets/images/backDashboard.svg";
import { useDispatch, useSelector } from "react-redux";
import { createReviewRequest } from "features/actions/auth";
import { Box, Button, IconButton, Modal, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs from "dayjs";
import toast from "react-hot-toast";
function ReviewDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const business_id = useSelector((state) => state.dashboard.commonId);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    phone_number: "",
    visit_date: dayjs().format("YYYY-MM-DD"),
    note: "",
    yelp_link: "",
    facebook_link: "",
    google_link: "",
    twitter_link: "",
  });

  const [open, setOpen] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleSubmit = () => {
    let errors = {};
    if (!formData.first_name.trim()) {
      errors.first_name = "First name is required";
    }
    if (!formData.last_name.trim()) {
      errors.last_name = "Last name is required";
    }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
   
    const formDataObject = {
      business_id,
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email_address,
      phone_number: formData.phone_number,
      visit_date: formData.visit_date,
      note: formData.note,
      status: "added",
      action: "pending",
    };

    dispatch(createReviewRequest(formDataObject));
    setOpen(true);
    setFormData({
      first_name: "",
      last_name: "",
      email_address: "",
      phone_number: "",
      visit_date: dayjs().format("YYYY-MM-DD"),
      note: "",
      yelp_link: "",
      facebook_link: "",
      google_link: "",
      twitter_link: "",
    });
    setFormErrors({});
    toast.success("Review Request has been added Successfully")
    navigate("/request-reviews");
  };

  // const handleClose = () => {
  //   setOpen(false);
   
  //   navigate("/request-reviews");
  // };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 24,
    p: 4,
    textAlign: "center",
  };

  const handleDateChange = (newDate) => {
    setFormData((prev) => ({
      ...prev,
      visit_date: newDate ? dayjs(newDate).format("YYYY-MM-DD") : "",
    }));
  };

  return (
    <MDBox sx={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <DashboardLayoutCustom2>
        <DashboardNavbar />

        <MDBox sx={{ px: "1rem" }}>
          <MDBox
            sx={{
              backgroundColor: "#ffffff",
              py: 1,
              borderRadius: "20px",
              height: "auto",
            }}
          >
            <MDBox sx={{ borderBottom: "1px solid #E1EAFF", px: 2, py: 1 }}>
              <MDTypography
                mt={2}
                mb={2}
                sx={{
                  color: "#292929",
                  fontFamily: "Urbanist",
                  fontSize: "24px",
                  fontWeight: 700,
                }}
              >
                Provide details for your Request Review
              </MDTypography>
            </MDBox>

            <MDBox sx={{ px: 2, py: 2 }}>
              <Grid container columnSpacing={5} rowSpacing={2}>
                {[
                  { label: "First Name", key: "first_name", required: true },
                  { label: "Last Name", key: "last_name" },
                  { label: "Email", key: "email_address", type: "email" },
                  { label: "Phone Number", key: "phone_number" },
                  { label: "Visit Date", key: "visit_date", required: true },
                  { label: "Note", key: "note" },
                ].map((field) => (
                  <Grid item xs={12} md={6} lg={4} key={field.key}>
                    <MDTypography variant="subtitle2" sx={{ color: "#212121" }} mt={1}>
                      {field.label}
                      {field.required && (
                        <MDBox sx={{ color: "red" }} component="span">
                          *
                        </MDBox>
                      )}
                    </MDTypography>
                    {field.key === "visit_date" ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={{ width: "100%" }}
                          value={formData.visit_date ? dayjs(formData.visit_date) : null}
                          onChange={handleDateChange}
                          renderInput={(params) => (
                            <TextField fullWidth sx={{ mt: 1 }} {...params} />
                          )}
                        />
                      </LocalizationProvider>
                    ) : (
                      <MDInput
                        type={field.type || "text"}
                        placeholder={field.label}
                        value={formData[field.key]}
                        error={!!formErrors[field.key]}
                        helperText={formErrors[field.key]}
                        onChange={(e) => handleChange(field.key, e.target.value)}
                        fullWidth
                        sx={{
                          "& .MuiInputBase-root": {
                            borderRadius: "45px",
                            paddingRight: "41px",
                          },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "45px",
                          },
                        }}
                      />
                    )}
                  </Grid>
                ))}
              </Grid>

              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 7,
                }}
              >
                <MDButton
                  sx={{
                    fontFamily: "urbanist",
                    padding: 0,
                    color: "#318BEC",
                  }}
                  component={Link}
                  to="/request-reviews"
                >
                  <img
                    src={backDashboard}
                    alt="Back"
                    style={{ marginRight: "10px", borderRadius: "20px" }}
                  />
                  Back
                </MDButton>

                <MDButton
                  variant="gradient"
                  color="info"
                  sx={{
                    px: 6,
                    py: 2,
                    borderRadius: "45px",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>

       
      </DashboardLayoutCustom2>
    </MDBox>
  );
}

export default ReviewDetail;
